type Properties = {
    message: string
};

const LoadingScreen = (props: Properties) => {
    return (
        <div className="loading-screen">
            <div className="lds-heart"><div/></div>
            <div className="lds-message">{props.message}</div>
        </div>
    );
};

export default LoadingScreen;